export default __webpack_public_path__ + "static/media/x.6e7af08b.mp4";